import {
  HonestPricingLawServiceFeeTypes,
  HONEST_PRICING_LAW_SERVICE_FEE_NAMES
} from 'base-ordering/constants/HonestPricingLaw';

export const getHonestLawServiceFeeText = (
  chargeServiceFee,
  displayServiceFee,
  feeType
) => {
  if (chargeServiceFee) {
    if (feeType === HonestPricingLawServiceFeeTypes.CATERING_ORDER) {
      return `A one-time ${displayServiceFee} ${HONEST_PRICING_LAW_SERVICE_FEE_NAMES[feeType]} applies to each catering order to help us provide you with the option to order catering online`;
    } else {
      return `A one-time ${displayServiceFee} ${HONEST_PRICING_LAW_SERVICE_FEE_NAMES[feeType]} applies to each order to help us provide you with the option to order online`;
    }
  }
  return '';
};
